import { combineReducers } from "redux";
import businessCardReducer from "./business/dashboardReducer";
import {loginReducer, userReducer, signupReducer} from "./common/authReducer";
import createCampaignReducer from "./business/CampaignReducer";
import adminCardReducer, { thisWeekBusinessReducer, thisWeekPaymentsReducer } from "./admin/dashboardReducer";
import {allLeadsAdminReducer, createLeadReducer, thisWeekLeadsReducer} from "./admin/LeadAdminReducer";
import { allLeadsReducer, getDuplicateReducer, submitduplicateReducer, thisWeekLeadBusinessReducer } from "./business/LeadReducer";
import { allTxnAdminReducer } from "./admin/TxnAdminReducer";
import { allTxnReducer, getWalletReducer } from "./business/TxnReducer";
import { getBusinessReducer } from "./admin/BusinessAdminReducer";
import {subscriptionReducer, viewSubscriptionReducer, updateSubscriptionReducer} from './admin/SubscriptionReducer';
import {viewSubTractionReducer} from './business/SubtractionReducter'
import {changePasswordReducer} from './business/ChangepasswordReducer';
import {forgotPasswordReducer} from './common/forgotPasswordReducer'
import adminAllLeadsReducer, { graphReducer } from "./admin/NewDashboardReducer";
import NewLeadModeReducer from "./common/NewLeadModeReducer";
// import posts from "./postReducer";

const rootReducer = combineReducers({
    businesscard:  businessCardReducer,
    admincard:  adminCardReducer,
    login:  loginReducer, // Maps the `login` key to `loginReducer`
    user: userReducer,
    signup: signupReducer,
    createCampaign:createCampaignReducer,
    changePassword:changePasswordReducer,
    forgotPassword : forgotPasswordReducer,
    subscriptionState:subscriptionReducer,
    viewSubscription: viewSubscriptionReducer,
    viewSubTraction: viewSubTractionReducer, /// tran
    updateSubscription: updateSubscriptionReducer,
    createLead: createLeadReducer,
    thisWeekLeads: thisWeekLeadsReducer,
    allLeadsAdmin: allLeadsAdminReducer,
    allLeads: allLeadsReducer,
    allTxnAdmin: allTxnAdminReducer,
    allTxn: allTxnReducer,
    wallet: getWalletReducer,
    thisWeekLeadBusiness: thisWeekLeadBusinessReducer,
    thisWeekBusiness: thisWeekBusinessReducer,
    thisWeekPayments: thisWeekPaymentsReducer,
    businessList: getBusinessReducer,
    submitduplicate: submitduplicateReducer,
    ticketList: getDuplicateReducer,
    adminAllLeads:adminAllLeadsReducer,
     graph: graphReducer,
     leadMode: NewLeadModeReducer,
});

export default rootReducer;
